import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { LandPage, Main, ThisProgress } from './styles';
import { Colors } from "~/config/Colors";
import { useSelector } from "react-redux";
import { Materialize } from "~/styles/materializeGrid";

import { Label, Input, Select as SelectCF } from "~/componentes/CustomForm";
import IconInsatisfeito from '~/assets/icones/icon_insatisfeito.png';
import IconMuitoInsatisfeito from '~/assets/icones/icon_muito_insatisfeito.png';
import IconSatisfeito from '~/assets/icones/icon_satisfeito.png';
import IconMuitosatisfeito from '~/assets/icones/icon_muito_satisfeito.png';
import IconNormal from '~/assets/icones/icon_muito_normal.png';
import IconArrowUp from '~/assets/icones/IconArrowUp.svg';
import IconArrowDown from '~/assets/icones/IconArrowDown.svg';

import Select from 'react-select';
import GaugeChart from 'react-gauge-chart';

export default function AvaliacaoUnidades() {
  const { perfil, idUnidades, controle } = useSelector(state => state.auth);
  const [chartPrincipal, setChartPrincipal] = useState([]);
  const [dataDe, setDataDe] = useState(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toISOString().slice(0, 10));
  const [dataAte, setDataAte] = useState(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10));
  const [pesquisas, setPesquisas] = useState();
  const [idPesquisa, setIdPesquisa] = useState();
  const [centroCustos, setCentroCustos] = useState();
  const [idCentroCusto, setIdCentroCusto] = useState([]);
  
  const [unidades, setUnidades] = useState([]);
  const [idUnidade, setIdUnidade] = useState([]);
    
  const cores = [
    "#2E7AD3",
    "#FF5780",
    "#802ED3",
    "#C62ED3",
    "#CAC4C8",
    "#CE6D14",
    "#D32EA5",
    "#14ADCE",
    "#4691C7",
    "#FF9090",
    "#D4F37B",
    "#FFF27E",
    "#4F4F4F",
    "#B9FFDE",
    "#B9D1FF",
  ];

  function atualizaChartPrincipal(data) {
    let lista = [];
    for (const itemData of data) {
      const itemFind = chartPrincipal.find((itemCP) => itemCP.id == itemData.id);
      if (itemFind) {
        lista.push({ ...itemData, aberto: itemFind?.aberto });
      } else {
        lista.push({ ...itemData, aberto: false });
      }
    }
  
    setChartPrincipal(lista);
  }

  useEffect(() => {
    api.get('/signed/cliente/pesquisa/relatorio/avaliacoesunidades', { params: { dataDe, dataAte, idCentroCusto, idPesquisa, idUnidade } })
      .then(response => atualizaChartPrincipal(response.data));
  }, [dataDe, dataAte, idCentroCusto, idPesquisa, idUnidade]);

  useEffect(() => {
    api.get('/signed/cliente/pesquisa/gerenciamento/pesquisas', { params: { ativo: 1 } }).then(response => {
      setPesquisas(response.data);

      if (response.data.length > 0) {
        setIdPesquisa(response.data[0].id);
      }
    });

    api.get('/signed/cliente/administracao/organizacao/unidades', { params: { centroCusto: "S", servico: "S" } }).then(response => {
      let lista = [];
      for (const item of idUnidades) {
        const itemFind = response?.data?.find((o) => o?.id == item);
        
        if (itemFind) {
          let listaCC = [];
          for (const itemCC of itemFind?.centroCustos) {
            listaCC.push({ value: itemCC?.id, label: itemCC?.titulo, color: "#00B8D9" });
          }

          let listaSer = [];
          for (const itemCC of itemFind?.servicos) {
            listaSer.push({ value: itemCC?.id, label: itemCC?.titulo, color: "#00B8D9" });
          }

          lista.push({ value: itemFind?.id, label: itemFind?.nome, color: "#00B8D9", centroCustos: listaCC, servicos: listaSer });
        }
      }
      setUnidades(lista);
    });
  }, []);

  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? Colors.Color2
          : undefined,
        color: Colors.Color7,
  
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : Colors.Color2
            : undefined,
        },
      };
    },
  };

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Materialize className="materialize">
            <div className="row header">
              <div className="divTitle">
                <div className="div-icone">
                  <h4 className="title">Avaliações das Unidades</h4>
                  <h5 className="sub-title">Visualize as informações e tenha uma análise prévia das pesquisas</h5>
                </div>
              </div>
            </div>
            <div className="row filtro">
              <Label title="" className="col s2 m2 l2 no-padd-l">
                <SelectCF
                  isNumber
                  list={{ list: pesquisas, value: 'id', label: 'titulo' }}
                  name="idPesquisa"
                  firstOption={"Pesquisa"}
                  defaultValue={idPesquisa}
                  onChange={(e) => {
                    const v = e.currentTarget.value;
                    setIdPesquisa(v);
                  }}
                />
              </Label>
              <Label title="" className="col s3 m3 l3">
                <Select
                  isMulti
                  name="colors"
                  options={unidades}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Unidades"
                  onChange={(e) => {
                    let ids = [];
                    let listaCC = [];
                    for (const itemE of e) {
                      ids.push(itemE?.value);
                      listaCC.push(...(itemE?.centroCustos))
                    }
                    setIdUnidade(ids);
                    setCentroCustos(listaCC);
                  }}
                  styles={colourStyles}
                />
              </Label>
              <Label title="" className="col s3 m3 l3">
                <Select
                  isMulti
                  name="colors"
                  options={centroCustos}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Centro de Custos"
                  onChange={(e) => {
                    let ids = [];
                    for (const itemE of e) {
                      ids.push(itemE?.value);
                    }
                    setIdCentroCusto(ids);
                  }}
                  styles={colourStyles}
                />
              </Label>
              <Label title="" className="col s2 m2 l2 no-padd-l">
                <Input
                  type="date"
                  name="dataDe"
                  defaultValue={dataDe}
                  onBlur={(e) => {
                    const v = e.currentTarget.value || "";
                    setDataDe(v);
                  }}
                />
              </Label>
              <Label title="" className="col s2 m2 l2">
                <Input
                  type="date"
                  name="dataAte"
                  defaultValue={dataAte}
                  onBlur={(e) => {
                    const v = e.currentTarget.value || "";
                    setDataAte(v);
                  }}
                />
              </Label>
            </div>
          </Materialize>
          <div className="back-section">
            {chartPrincipal?.map((itemUnidade, indiceUnidade) => (
              <div className="section-1" key={itemUnidade?.idUnidade}>
                <div 
                  className="sc-top"
                  onClick={() => {
                    setChartPrincipal((state) => {
                      let lista = [...state];
                      
                      lista[indiceUnidade].aberto = !lista[indiceUnidade].aberto;

                      return lista;
                    });

                  }}
                >
                  <div className="div-title">
                    <div className="title">
                      {indiceUnidade + 1}. {itemUnidade?.titulo}
                    </div>
                    <div className="div-sumary">
                      <div className="item-pergunta">
                        {itemUnidade?.percentualSatisfacao >= 80
                          ? (
                            <div className="col-1-1 align-left">
                              <img src={IconMuitosatisfeito} alt="" />
                            </div>
                          ) : itemUnidade?.percentualSatisfacao >= 60 ? (
                            <div className="col-1-1 align-left">
                              <img src={IconSatisfeito} alt="" />
                            </div>
                          ) : itemUnidade?.percentualSatisfacao >= 40 ? (
                            <div className="col-1-1 align-left">
                              <img src={IconNormal} alt="" />
                            </div>
                          ) : itemUnidade?.percentualSatisfacao >= 20 ? (
                            <div className="col-1-1 align-left">
                              <img src={IconInsatisfeito} alt="" />
                            </div>
                          ) : (
                            <div className="col-1-1 align-left">
                              <img src={IconMuitoInsatisfeito} alt="" />
                            </div>
                          )
                        }
                        <div className="col-1-1 align-right">
                          <p className="titulo-item">{(itemUnidade?.percentualSatisfacao || 0)?.toFixed(1)}%</p>
                        </div>
                        <div className="col-2 align-right">
                          <p className="titulo-item">{(itemUnidade?.quantidade || 0)} Resposta(s)</p>
                        </div>
                      </div>
                      <div className="chart-total">
                        <div className="chart-tt-circle">
                          <GaugeChart id="gauge-chart5"
                            arcsLength={[0.2, 0.2, 0.2, 0.2, 0.2]}
                            colors={['#FF5780', '#FFAB48', '#FFD147', '#B6DF53', '#2ed3b5']}
                            textColor={Colors.Color3}
                            hideText={true}
                            percent={itemUnidade?.percentualSatisfacao / 100}
                            arcPadding={0.02}
                            needleColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                            needleBaseColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                            style={{ width: '90%' }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {!itemUnidade.aberto && (<img className="icon-arrow" src={IconArrowDown} alt="" />)}
                  {itemUnidade.aberto && (<img className="icon-arrow" src={IconArrowUp} alt="" />)}
                </div>
                {itemUnidade.aberto && (
                  <div className="chart-barra">
                    <div className="list">
                      {itemUnidade?.perguntas?.map((itemItem, a) => (
                        <div className="item-pergunta">
                          {itemItem?.percentualSatisfacao >= 80
                            ? (
                              <div className="col-1-1 align-left">
                                <img src={IconMuitosatisfeito} alt="Vazio" />
                              </div>
                            ) : itemItem?.percentualSatisfacao >= 60 ? (
                              <div className="col-1-1 align-left">
                                <img src={IconSatisfeito} alt="Vazio" />
                              </div>
                            ) : itemItem?.percentualSatisfacao >= 40 ? (
                              <div className="col-1-1 align-left">
                                <img src={IconNormal} alt="Vazio" />
                              </div>
                            ) : itemItem?.percentualSatisfacao >= 20 ? (
                              <div className="col-1-1 align-left">
                                <img src={IconInsatisfeito} alt="Vazio" />
                              </div>
                            ) : (
                              <div className="col-1-1 align-left">
                                <img src={IconMuitoInsatisfeito} alt="Vazio" />
                              </div>
                          )}
                          <div className="col-5">
                            <p className="titulo-item">{itemItem?.titulo}</p>
                          </div>
                          <div className="col-3">
                            <div className="progress">
                              {
                                itemItem?.percentualSatisfacao >= 80
                                  ? (
                                    <ThisProgress backgound={'#2ED3B5'} width={itemItem?.percentualSatisfacao + "%"} />
                                  ) : itemItem?.percentualSatisfacao >= 60 ? (
                                    <ThisProgress backgound={'#B6DF53'} width={itemItem?.percentualSatisfacao + "%"} />
                                  ) : itemItem?.percentualSatisfacao >= 40 ? (
                                    <ThisProgress backgound={'#FFD147'} width={itemItem?.percentualSatisfacao + "%"} />
                                  ) : itemItem?.percentualSatisfacao >= 20 ? (
                                    <ThisProgress backgound={'#FFAB48'} width={itemItem?.percentualSatisfacao + "%"} />
                                  ) : (
                                    <ThisProgress backgound={'#FF5780'} width={itemItem?.percentualSatisfacao + "%"} />
                                  )
                              }
                            </div>
                          </div>
                          <div className="col-1-1 align-center">
                            <p className="titulo-item">|</p>
                          </div>
                          <div className="col-1 align-right">
                            <p className="titulo-item">{itemItem?.quantidade}</p>
                          </div>
                          <div className="col-1-1 align-center">
                            <p className="titulo-item">|</p>
                          </div>
                          <div className="col-1-1 align-right">
                            <p className="titulo-item">{itemItem?.percentualSatisfacao?.toFixed(1)}%</p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="chart-total">
                      <div className="chart-tt-circle">
                        <GaugeChart id="gauge-chart5"
                          arcsLength={[0.2, 0.2, 0.2, 0.2, 0.2]}
                          colors={['#FF5780', '#FFAB48', '#FFD147', '#B6DF53', '#2ed3b5']}
                          textColor={Colors.Color3}
                          percent={itemUnidade?.percentualSatisfacao/100}
                          arcPadding={0.02}
                          needleColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                          needleBaseColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                          style={{ width: '90%' }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </LandPage>
    </Main>
  );
}
